import { Injectable } from '@angular/core'
import {
  BasePageMetaResolver,
  CategoryPageMetaResolver,
  CmsService,
  OccEndpointsService,
  ProductSearchService,
  TranslationService,
  WindowRef,
  ProductSearchPage
} from '@spartacus/core'
import { ProductListComponentService } from '@spartacus/storefront'
import {combineLatest, EMPTY, Observable, of} from 'rxjs'
import { filter, switchMap } from 'rxjs/operators'
import { EBOGPMetaData, EbPage } from '../../../cms/interfaces/eb-page.interface'
import { EbProductSearchPage } from '../../interfaces/eb-product.interface'

@Injectable({
  providedIn: 'root'
})
export class EbCategoryPageMetaResolver extends CategoryPageMetaResolver {
  constructor(
    productSearchService: ProductSearchService,
    cms: CmsService,
    translation: TranslationService,
    basePageMetaResolver: BasePageMetaResolver,
    protected productListComponentService: ProductListComponentService,
    protected occEndpoints: OccEndpointsService,
    protected winRef: WindowRef
  ) {
    super(productSearchService, cms, translation, basePageMetaResolver)
  }

  protected page$ = this.cms.getCurrentPage() as Observable<EbPage>
  protected searchPage$: Observable<ProductSearchPage> = EMPTY

  resolveTitle(): Observable<string> {
    return combineLatest([this.searchPage$, this.page$]).pipe(
      filter(([productSearchPage, _page]) => !!productSearchPage.pagination),
      switchMap(([productSearchPage, page]) => {
        const title = []
        const breadcrumbsReverted = [...(productSearchPage?.breadcrumbs ?? [])].reverse()
        const metaTitle = page?.metaTitle ?? ''
        let charCount = metaTitle?.length
        breadcrumbsReverted.forEach(breadcrumb => {
          if (charCount < 70) {
            title.push(breadcrumb?.facetValueName)
            charCount += breadcrumb?.facetValueName.length
          }
        })
        if (metaTitle) {
          title.push(metaTitle)
        }

        return this.translation.translate('pageMetaResolver.category.title', {
          count: productSearchPage?.pagination?.totalResults,
          query: title.join(' | ')
        })
      })
    )
  }

  resolveOGPMetaData(): Observable<EBOGPMetaData> {
    const baseUrlWithoutPrefixAndBaseSite = this.occEndpoints.getBaseUrl({
      baseUrl: true,
      prefix: false,
      baseSite: false
    })

    return combineLatest([this.page$, this.productListComponentService.model$]).pipe(
      switchMap(([page, productModel]) => {
        const ebProductModel = productModel as EbProductSearchPage
        const categoryDescriptionWithoutHtmlTags =
          ebProductModel.categoryDescription?.replace(/<\/?[^>]+(>|$)/g, '') || page.metaDescription
        let imageUrl = ebProductModel?.categoryImage || page?.logo
        imageUrl = imageUrl.includes(baseUrlWithoutPrefixAndBaseSite)
          ? imageUrl
          : baseUrlWithoutPrefixAndBaseSite + imageUrl
        return of({
          title: ebProductModel.categoryName || page.title || page.metaTitle,
          description: categoryDescriptionWithoutHtmlTags || page.metaDescription,
          type: 'website',
          url: this.winRef.location.href,
          image: imageUrl || ''
        })
      })
    )
  }
}
